import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {useHistory} from 'react-router-dom';
import {useQuery} from "@apollo/client";
import 'react-awesome-slider/dist/styles.css';
import NextIcon from '@mui/icons-material/ArrowForward';
import presentIcon from '../../assets/images/present.png';
import {GET_LECTION_QUERY} from '../../queries/queries';
import Error from '../error';
import Loading from '../loading';
import PlayLection from 'components/lections/play-lection';
import closeIcon from '../../assets/images/close_icon.png'

const styles = theme => ({
  root: {
    color: '#fff',
    backgroundColor: '#4397E6',
    height: '100vh',
    backgroundImage: 'linear-gradient(to top,#7CD1EA 0%, #4397E6 100%)',
  },
  header: {
    fontSize: 27,
    fontWeight: 200,
  },
  presentIcon: {
    margin: '20px 0px',
  },
  points: {
    fontSize: 34,
    fontWeight: 600,
  },
  description: {
    fontSize: 15,
    padding: '10px 0px',
    fontWeight: 100,
  },
  button: {
    margin: theme.spacing ? theme.spacing(2) : "16px",
    backgroundColor: '#fff',
    borderRadius: 30,
    width: 320,
    height: 56,
    color: '#238CB9',
    fontWeight: 'bold',
  },
  buttonText: {
    margin: 0,
    fontSize: 16,
    fontWeight: 'bold',
  },
  buttonBox: {
    position: 'relative',
  },
  nextIcon: {
    marginLeft: 10,
  },
});

const Success = ({
  classes,
  nextSections,
  match: {
    params: {lectionId},
  },
}) => {
  let history = useHistory();
  const {loading, error, data} = useQuery(GET_LECTION_QUERY, {
    variables: {id: lectionId},
    fetchPolicy: 'no-cache',
  });

  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    if (data?.section?.popupIframeUrl) {
      setShowPopUp(true);
    }
  }, [data]); 

  if (loading) return <Loading />;
  if (error) return <Error />;

  const lection = data.section;

  const popupIframeUrl = data?.section?.popupIframeUrl;

  return (
    <Box className={classes.root} display="flex" flexDirection="column" justifyContent="center">
      {showPopUp &&  <div className="modal-overlay">
        <div className="modal-container-popup">
        <div 
          className="modal-closeButton"
          onClick={() => setShowPopUp(false)} 
        >
          <img src={closeIcon} alt="Close" />
        </div>
          <PlayLection
            iFrameUrl={popupIframeUrl}
            popup={true}
          />
        </div>
      </div>}
      <Box
        display="flex"
        height="70%"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-around">
        <Typography
          align="center"
          className={classes.header}
          variant="body1"
          component="p">
          Herzlichen <br />
          Glückwunsch!
        </Typography>
        <img
          alt="No courses left"
          src={presentIcon}
          className={classes.presentIcon}
        />
        <Box className={classes.descriptionBox}>
          <Typography
            className={classes.points}
            align="center"
            variant="body1"
            component="p">
            {lection.credits} Punkte
          </Typography>
          <Typography
            className={classes.description}
            align="center"
            variant="body1"
            component="p">
            Du hast die Lektion erfolgreich beendet
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Button
            className={classes.button}
            variant="contained"
            color="inherit"
            size="large"
            onClick={e => {
              e.preventDefault();
              history.push(`/course_details/${lection.courseId}`);
            }}>
            <Box display="flex" alignItems="center">
              <Typography
                gutterBottom
                align="left"
                variant="button"
                component="p"
                className={classes.buttonText}
                color="inherit">
                Zurück zum Kurs
              </Typography>
              <NextIcon className={classes.nextIcon} />
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(Success);
